import script from "./ClassInfoView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassInfoView.vue?vue&type=script&setup=true&lang=js"

import "./ClassInfoView.vue?vue&type=style&index=0&id=6d455f76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d455f76"]])

export default __exports__